import { render, staticRenderFns } from "./signAndUnsign.vue?vue&type=template&id=0a95bfd0&scoped=true"
import script from "./signAndUnsign.vue?vue&type=script&lang=js"
export * from "./signAndUnsign.vue?vue&type=script&lang=js"
import style0 from "./signAndUnsign.vue?vue&type=style&index=0&id=0a95bfd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a95bfd0",
  null
  
)

export default component.exports